import type { CreateReturnLabelInput } from 'Portal/__generated__/globalTypes'

import type { PortalReturnLabelModalFormSchema } from './PortalReturnLabelModal.types'

const GERMANY_COUNTRY_CODE = 'DE'

export const portalReturnLabelFormToInput = (
  data: PortalReturnLabelModalFormSchema,
  ids: {
    employeeId?: string | null
    organisationId: string
    returnCaseIds: string[]
  },
): CreateReturnLabelInput => {
  const isNonGerman = data.country?.value && data.country.value !== GERMANY_COUNTRY_CODE

  return {
    employeeId: ids.employeeId,
    organisationId: ids.organisationId,
    returnCaseIds: ids.returnCaseIds,
    senderAddress: {
      city: data.city,
      countryCode: data.country?.value || '',
      email: isNonGerman ? (data.email || null) : null,
      fullName: data.fullName,
      phoneNumber: isNonGerman ? (data.phoneNumber || null) : null,
      postalCode: data.zipcode,
      street: data.street,
      streetNumber: data.streetNumber,
    },
  }
}
